var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgErro404Image = function SvgErro404Image(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 570,
    height: 317,
    viewBox: "0 0 570 317",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 570,
    height: 316,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5918 260.031C64.5556 260.031 77.7596 254.908 88.6232 244.578C101.614 232.22 109.131 214.648 116.403 197.655C124.622 178.451 132.382 160.307 146.562 155.771C152.806 153.774 158.493 154.445 163.929 157.829C187.852 172.718 196.916 231.984 197.007 232.578L205.088 231.374C204.7 228.782 195.338 167.748 168.244 150.884C160.75 146.219 152.615 145.243 144.062 147.98C126.329 153.659 117.852 173.465 108.879 194.43C94.9355 227.013 80.5193 260.717 30.3334 249.701L6.05233 241.849C3.90248 241.155 1.60016 242.329 0.90642 244.479C0.212675 246.629 1.3867 248.931 3.53655 249.625L28.3741 257.645C35.5555 259.23 42.2795 260.031 48.5766 260.031H48.5918Z",
    fill: "url(#paint0_linear_1348_2294)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.707 300.398L178.009 258.232C175.005 243.671 183.49 229.194 197.655 224.688C213.512 219.649 230.345 228.934 234.545 245.028L245.218 285.928L186.707 300.398V300.398Z",
    fill: "url(#paint1_linear_1348_2294)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.722 301.511C187.659 305.391 201.679 305.338 218.047 301.396C234.407 297.455 246.917 291.112 245.979 287.232C245.042 283.351 231.022 283.405 214.662 287.346C198.302 291.288 185.791 297.63 186.729 301.511H186.722Z",
    fill: "#000958"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.055 290.068C221.819 291.379 224.16 292.896 227.285 293.453C230.411 294.017 233.133 293.407 233.361 292.096C233.598 290.784 231.257 289.267 228.131 288.711C225.006 288.147 222.284 288.757 222.055 290.068Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.438 296.395C201.202 297.707 203.542 299.224 206.668 299.78C209.794 300.344 212.515 299.735 212.752 298.423C212.988 297.112 210.648 295.595 207.522 295.038C204.396 294.474 201.675 295.084 201.446 296.395H201.438Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.91 229.628C212.91 229.628 225.527 234.218 229.545 247.406C233.562 260.595 237.001 277.512 237.001 277.512L225.527 277.802L212.91 229.628V229.628Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M570 203.548L566.752 210.775C566.188 210.524 552.771 204.295 540.451 182.37C536.891 176.035 531.425 168.617 525.631 169.303C521.476 169.791 510.452 175.699 497.919 219.817C484.25 267.929 455.014 299.361 411.026 313.251C382.552 322.239 347.346 303.058 345.859 302.235L349.694 295.305C350.136 295.549 383.474 313.64 408.639 305.704C449.929 292.667 477.404 263.05 490.303 217.659C500.618 181.348 511.878 162.96 524.708 161.443C532.843 160.482 540.459 166.223 547.358 178.497C558.412 198.173 569.886 203.502 570 203.556V203.548ZM349.694 295.298L347.781 298.766L349.694 295.298Z",
    fill: "url(#paint2_linear_1348_2294)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.179 266.473L297.045 281.59C298.791 282.856 299.179 285.295 297.914 287.034C296.648 288.779 294.209 289.168 292.471 287.903L271.605 272.785C269.859 271.52 269.47 269.08 270.736 267.342C272.001 265.596 274.441 265.207 276.179 266.473V266.473Z",
    fill: "#000958"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.281 243.305L313.146 258.422C314.892 259.688 315.281 262.127 314.015 263.866C312.75 265.611 310.31 266 308.572 264.735L287.706 249.617C285.961 248.352 285.572 245.912 286.837 244.174C288.103 242.428 290.542 242.039 292.281 243.305V243.305Z",
    fill: "#000958"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.773 288.109L313.871 311.574C326.336 319.678 342.909 317.055 352.263 305.498C362.73 292.568 360.222 273.509 346.767 263.728L312.567 238.883L277.773 288.101V288.109Z",
    fill: "url(#paint3_linear_1348_2294)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.871 289.824L298.181 278.579L340.819 309.287C340.819 309.287 330.604 314.379 318.833 308.662C307.07 302.944 289.871 289.824 289.871 289.824Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.743 104.972V2.35514H155.965L87 110.692L88.2396 130.206H156.416V165.645H187.743V130.206H206.787V104.972H187.743ZM117.764 104.972L153.373 49.6822L156.416 44.2991V104.972H117.764Z",
    fill: "#000958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.675 103.514V64.486C341.675 53.9439 340.435 44.6729 337.956 36.6729C335.477 28.5981 331.946 21.8318 327.364 16.3738C322.706 10.9907 317.071 6.91589 310.46 4.14953C303.849 1.38318 296.412 0 288.148 0C279.96 0 272.56 1.38318 265.949 4.14953C259.413 6.91589 253.853 10.9907 249.271 16.3738C244.613 21.8318 241.045 28.5981 238.565 36.6729C236.086 44.6729 234.847 53.9439 234.847 64.486V103.514C234.847 114.056 236.086 123.364 238.565 131.439C241.12 139.439 244.726 146.131 249.383 151.514C253.966 156.972 259.563 161.084 266.174 163.85C272.785 166.617 280.185 168 288.374 168C296.637 168 304.075 166.617 310.686 163.85C317.297 161.084 322.894 156.972 327.476 151.514C332.059 146.131 335.552 139.439 337.956 131.439C340.435 123.364 341.675 114.056 341.675 103.514ZM266.399 90.0561C266.399 87.7383 266.399 85.9813 266.399 84.785C266.399 83.5888 266.399 81.1963 266.399 77.6075V59.5514C266.399 53.4953 266.85 48.2617 267.752 43.8505C268.728 39.4393 270.193 35.8505 272.146 33.0841C273.949 30.4673 276.166 28.5234 278.795 27.2523C281.5 25.9065 284.617 25.2336 288.148 25.2336C291.303 25.2336 294.121 25.757 296.6 26.8037C299.154 27.7757 301.295 29.3084 303.023 31.4019C305.277 34.0187 306.967 37.5327 308.094 41.9439C309.296 46.2804 309.972 51.514 310.122 57.6449L266.399 90.0561ZM310.122 108.224C310.122 114.28 309.634 119.551 308.657 124.037C307.756 128.449 306.366 132.075 304.488 134.916C302.685 137.607 300.431 139.626 297.727 140.972C295.022 142.243 291.904 142.879 288.374 142.879C284.542 142.879 281.237 142.131 278.457 140.636C275.677 139.14 273.386 136.86 271.583 133.794C270.005 131.252 268.766 128.075 267.864 124.262C267.038 120.449 266.55 116.075 266.399 111.14L310.122 78.8411C310.122 81.0093 310.122 82.6916 310.122 83.8878C310.122 85.0093 310.122 86.8037 310.122 89.271V108.224Z",
    fill: "#000958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.956 104.972V2.35514H433.178L364.213 110.692L365.452 130.206H433.628V165.645H464.956V130.206H484V104.972H464.956ZM394.976 104.972L430.586 49.6822L433.628 44.2991V104.972H394.976Z",
    fill: "#000958"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1348_2294",
    x1: 199.7,
    y1: 219.271,
    x2: 7.96729,
    y2: 260.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000958",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1348_2294",
    x1: 240.827,
    y1: 251.256,
    x2: 175.242,
    y2: 266.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1348_2294",
    x1: 565.633,
    y1: 209.36,
    x2: 367.42,
    y2: 250.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000958",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1348_2294",
    x1: 309.259,
    y1: 313.8,
    x2: 338.792,
    y2: 236.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000958"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgErro404Image);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/erro404-image.f0b0b41c5f6cc967c8802c1610d8700d.svg";